
import { DeviceType } from '@/store/modules/app/state'
import {
  computed,
  defineComponent,
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  reactive,
  toRefs,
  watch
} from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store'
import { AppActionTypes } from '@/store/modules/app/action-types'
import { AppMain, Navbar, Settings, TagsView, Sidebar } from './components'
import RightPanel from '@/components/right_panel/Index.vue'
import Notice from './components/notice/index.vue'
import resize from './resize'
import webSocket from '@/mqtt'
import sessionGuard from './sessionGuard'
import storage, { StorageType } from '@/utils/storage'
export default defineComponent({
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    RightPanel,
    Settings,
    Sidebar,
    TagsView,
    Notice
  },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const {
      sidebar,
      device,
      addEventListenerOnResize,
      resizeMounted,
      removeEventListenerResize,
      watchRouter
    } = resize()
    const state = reactive({
      handleClickOutside: () => {
        store.dispatch(AppActionTypes.ACTION_CLOSE_SIDEBAR, false)
      },
      pwdDialog: false,
      managerId: JSON.parse(
        storage.rcGetItem(StorageType.local, 'userInfo') || '""'
      ),
      showMarquee: true
    })
    const classObj = computed(() => {
      return {
        hideSidebar: !sidebar.value.opened,
        openSidebar: sidebar.value.opened,
        withoutAnimation: sidebar.value.withoutAnimation,
        mobile: device.value === DeviceType.Mobile
      }
    })

    const showSettings = computed(() => {
      return store.state.settings.showSettings
    })
    const showTagsView = computed(() => {
      return store.state.settings.showTagsView
    })
    const fixedHeader = computed(() => {
      return store.state.settings.fixedHeader
    })
    watchRouter()
    onBeforeMount(() => {
      addEventListenerOnResize()
    })
    const onShowNotice = () => {
      if (storage.rcGetItem(StorageType.session, 'reminder')) {
        // 缓存有 不显示
        state.showMarquee = false
      } else {
        if (!store.getters?.noticeList?.length) {
          state.showMarquee = false
        } else {
          state.showMarquee = true
        }
      }
    }
    onMounted(() => {
      webSocket.init()
      // 会话续期由单例维护，切换菜单分组导致的重新挂载不会重置计时
      sessionGuard.start()
      resizeMounted()
      onShowNotice()
    })

    onBeforeUnmount(() => {
      removeEventListenerResize()
    })
    const revisePwd = () => {
      state.pwdDialog = true
    }
    const closeNotice = (val: boolean) => {
      state.showMarquee = val
    }
    watch(
      () => store.getters.noticeList,
      () => {
        onShowNotice()
      }
    )
    return {
      t,
      classObj,
      sidebar,
      showSettings,
      showTagsView,
      fixedHeader,
      ...toRefs(state),
      revisePwd,
      closeNotice
    }
  }
})
